<template>
  <div>
    <router-link :to="{ name: link, novelId }" class="link">
      <div>
        <slot />
      </div>
      <div class="label">{{ label }}</div>
    </router-link>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    link: String,
    novelId: String,
    label: String,
  },
});
</script>

<style lang="scss" scoped>
.link {
  text-align: center;
  text-decoration: none;
  font-family: "Courier New", Courier, monospace;
  color: var(--color-text-normal);
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  &:visited {
    color: var(--color-text-normal);
  }
}

.label {
  font-size: smaller;
}
</style>
